import { useCallback, useEffect, useState } from "react";
import { useFunnelsApi } from "../api/funnelsApi";

export const useFunnels = () => {
  const api = useFunnelsApi();
  const [funnels, setFunnels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchFunnels = useCallback(async () => {
    try {
      setLoading(true);
      const data = await api.getAll();
      setFunnels(data);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [api]);

  const addFunnel = async (funnelData) => {
    const newFunnel = await api.create(funnelData);
    setFunnels((prev) => [...prev, newFunnel]);
  };

  const updateFunnel = async (id, funnelData) => {
    const updatedFunnel = await api.update(id, funnelData);

    setFunnels((prev) =>
      prev.map((funnel) =>
        funnel.id === id ? { ...funnel, ...updatedFunnel } : funnel,
      ),
    );
  };

  const deleteFunnel = async (id) => {
    await api.remove(id);
    setFunnels((prev) => prev.filter((funnel) => funnel.id !== id));
  };

  useEffect(() => {
    fetchFunnels();
  }, [fetchFunnels]);

  return {
    funnels,
    loading,
    error,
    fetchFunnels,
    addFunnel,
    updateFunnel,
    deleteFunnel,
  };
};
